import React from "react";
import Carousel from "../../components/commalax/carousel";
import Dropdown from "../../components/commalax/dropdown";
import {
  carenelCategories,
  hotProducts,
  innisfreeCategories,
  JMsolutionCategories,
} from "../../template_codes/commalax/home_page_codes";
import AdminCollections from "./admin_collections";
import BestSeller from "./best_seller";
import NewArrival from "./new_arrival";

const HomePage = () => {
  console.log(hotProducts);
  return (
    <div className="relative">
      <Carousel />
      <div className="flex justify-center items-center py-5 bg-white">
        <ul className="mb-4 mt-2 flex flex-wrap gap-2 lg:mb-0 lg:mt-0 lg:flex-row lg:items-center lg:gap-6 text-black">
          <Dropdown category={"CARE:NEL"} dropdownData={carenelCategories} />
          <Dropdown category={"innisfree"} dropdownData={innisfreeCategories} />
          <Dropdown
            category={"JM solution"}
            dropdownData={JMsolutionCategories}
          />
        </ul>
      </div>
      <BestSeller />
      <NewArrival />
      <div className="flex flex-col items-center gap-5 lg:flex-row lg:gap-0 px-10 justify-center flex-wrap py-10">
        <div className="w-full md:w-1/2 flex justify-center">
          <img
            src="https://jmsolution.com/web/product/extra/small/202211/26fc80c4ec284462a5847e40b452acb3.jpg"
            alt=""
            className="rounded-lg w-96 shadow-xl"
          />
        </div>
        <div className="flex justify-center w-full md:w-1/2 flex-col">
          <h1 className="text-2xl italic text-white font-bold mb-5">
            Product Title
          </h1>
          <p className="tracking-wider leading-8 ">
            Lorem ipsum dolor sit amet consectetur adipisicing elit. Amet
            quibusdam fugiat laudantium, quaerat deleniti officia! Porro
            doloribus dolorem, quae saepe delectus ab blanditiis assumenda minus
            provident voluptatibus sit cum veniam.
          </p>
        </div>
      </div>
      <AdminCollections />
    </div>
  );
};

export default HomePage;
